/**
 * Number formatters
 * --------------
 * All formatters are setup to use the browsers default locale which determines the 
 * way numbers are formatted e.g. with , or . as thousand separator.
 * - Large numbers on the dashboard use formatNumber()
 * - Use formatNumberDecimals() for billing where preciseness is important
 */


// Find the locale of the browser
const globalLocale = (navigator.languages?.[0] || navigator.language) || "en-US";

// Null helper
type NullableNumber = number | null | undefined;
function isNullish(value: NullableNumber): value is null | undefined {
  return value === null || value === undefined;
}

// Returns number with thousand seperator and no decimals: e.g. 1000,56 -> 1.000
export function formatNumber(number: NullableNumber, locale: string = globalLocale): string {
  if (isNullish(number)) return "-";
  return number.toLocaleString(locale, { maximumFractionDigits: 0 });
};

// Returns number with thousand seperator and two decimals: e.g. 1000,56 -> 1.000,56
export function formatNumberDecimals(number: NullableNumber, decimals: number = 2, locale: string = globalLocale): string {
  if (isNullish(number)) return "-";
  return number.toLocaleString(locale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
};
